module.exports = __webpack_public_path__ + "static/media/09-05.6f46f5cb.png";